export const login_en = {
  title: 'Login',
  tr: "Turkish",
  en: "English",

  login: "Login",
  username: "Username",
  password: "Password",
};
